import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useAudienceOptions = () => {
  const filterColumns = useSelector((state) => state.resonance.filterColumns);

  return useMemo(() => {
    return filterColumns.map((column) => ({
      label: column.header,
      value: column.header,
    }));
  }, [filterColumns]);
};

export default useAudienceOptions;
